module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button":{"unplanned-leave":"Unplanned Leave"},"heading":{"availability-for":"Availability For {name}"},"message":{"unplanned-leave-confirm":"Confirm Unplanned Leave for Shift"}},"es":{}}')
  delete Component.options._Ctor
}
